angular.module('appMarketplace')
    .service('OrgSettingsService', ['$http', 'UrlService', function ($http, UrlService) {
        var service = this;

        service.getCatalogueSearchSettings = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/settings/catalogue'),
                cache: true
            };

            return $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };

        service.getPunchOutSupplierSettings = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/settings/punchOutSupplier'),
                cache: true
            };

            return $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };

        service.getUnspscCategories = function (searchParams, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/settings/categories'),
                cache: true,
                data: searchParams
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };

        service.getSupplierDirectorySettings = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/settings/supplierDirectory')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data);
            });
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/org-settings-service.js
// module id = 47
// module chunks = 37